var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouting2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64657 6.50016C4.93523 6.50016 5.9799 5.45549 5.9799 4.16683C5.9799 2.87816 4.93523 1.8335 3.64657 1.8335C2.3579 1.8335 1.31323 2.87816 1.31323 4.16683C1.31323 5.45549 2.3579 6.50016 3.64657 6.50016Z",
    stroke: "#808897"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3133 10.5H13.3133C14.0466 10.5 14.6466 11.1 14.6466 11.8333V13.8333C14.6466 14.5667 14.0466 15.1667 13.3133 15.1667H11.3133C10.58 15.1667 9.97998 14.5667 9.97998 13.8333V11.8333C9.97998 11.1 10.58 10.5 11.3133 10.5Z",
    stroke: "#808897"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 3.8335H9.78655C11.0199 3.8335 11.5932 5.36016 10.6665 6.1735L5.33988 10.8335C4.41322 11.6402 4.98655 13.1668 6.21322 13.1668H7.99988",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65748 4.16683H3.66518",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3242 12.8333H12.3319",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouting2);
export default __webpack_public_path__ + "static/media/routing-2.456e132b24e56c39d9f15b02653769a9.svg";
export { ForwardRef as ReactComponent };